module.exports = __webpack_public_path__ + "img/pdf.4f37c4ad.svg";